const featureItems = [
  {
    icon: 'ri-timer-flash-line',
    title: '24小时滚动更新',
    desc: '全天候不间断更新机制，确保最新黑料视频第一时间上线。刷新即有新内容，不错过任何爆料。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '匿名爆料保护',
    desc: '严格保护爆料人隐私信息，采用多层加密与匿名处理技术，让您安心分享内幕信息。',
  },
  {
    icon: 'ri-group-line',
    title: '活跃社区互动',
    desc: '50万+活跃用户组成的黑料社区，支持评论讨论、话题投票与内容分享，交流氛围热烈。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度内容追踪',
    desc: '黑料社编辑团队对每个热点事件进行深度调查与持续追踪，提供多角度、多信源的完整报道。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝体验',
    desc: '支持桌面端与移动端自适应浏览，随时随地访问黑料视频，体验一致流畅的观看感受。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            为什么选择黑料视频作为你的爆料信息源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="group text-center p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-300/40 transition-all"
            >
              <span className="inline-flex w-14 h-14 md:w-16 md:h-16 items-center justify-center rounded-2xl bg-primary-100/70 text-primary-600 text-2xl mb-4">
                <i className={item.icon} />
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}